import { Blocks } from "@builder.io/sdk-react";

import { usePaginatedSlice } from "~/hooks/learning-center/use-article-pagination";

import { PaginatedGridDisplay } from "./paginated-grid-display";
import type { ArticleGridProps } from "./types";

/**
 * SFCC-11498 (ARTICLES-12) — port of composable `customGrid.jsx`.
 *
 * Hand-picked mode: renders the author-selected ArticleCard children
 * (`articleCards` uiBlocks) via `<Blocks>`, paginated client-side. The slice is
 * a prefix of `articleCards`, so the mapped index aligns with the original list
 * index that `<Blocks path>` requires.
 */

export function CustomGrid({
  articleCards = [],
  itemsToShowPerLoad,
  builderBlock,
  attributes,
}: ArticleGridProps) {
  const {
    displayedItems,
    displayedCount,
    totalCount,
    showNextEntries,
    showAll,
    allEntriesDisplayed,
  } = usePaginatedSlice(articleCards, itemsToShowPerLoad);

  const blocks = displayedItems.map((entry, index) => (
    <div key={index}>
      <Blocks
        path={`component.options.articleCards.${index}.content`}
        blocks={(entry?.content ?? []) as never}
        parent={builderBlock?.id}
        data-testid="customGrid-Blocks"
      />
    </div>
  ));

  return (
    <PaginatedGridDisplay
      items={blocks}
      itemsText={`Showing ${displayedCount} of ${totalCount} articles`}
      onShowMore={showNextEntries}
      onShowAll={showAll}
      allEntriesDisplayed={allEntriesDisplayed}
      attributes={attributes}
    />
  );
}

export default CustomGrid;
